export const messages = {
  en: {
    partnerGoods: {
      queryCondition: 'Query Conditions',
      placeholder: {
        productId: 'Please select product ID',
        productName: 'Please select product name',
        productDesc: 'Please select product description',
        state: 'Please select status'
      },
      query: 'Search',
      partnerGoods: 'Partner Goods',
      syncStock: 'Sync Stock',
      syncPrice: 'Sync Price',
      syncGoods: 'Sync Goods',
      productId: 'Product ID',
      productName: 'Product Name',
      productDesc: 'Product Description',
      specId: 'Spec ID',
      externalCode: 'External Code',
      state: 'Status',
      syncSuccess: 'Sync Success',
      syncFailed: 'Sync Failed',
      syncRemark: 'Sync Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      delete: 'Delete',
      selectPartner: 'Please select partner'
    }
  },
  zh: {
    partnerGoods: {
      queryCondition: '查询条件',
      placeholder: {
        productId: '请选择产品id',
        productName: '请选择商品名称',
        productDesc: '请选择商品简介',
        state: '请选择状态'
      },
      query: '查询',
      partnerGoods: '合作商品',
      syncStock: '同步库存',
      syncPrice: '同步价格',
      syncGoods: '同步商品',
      productId: '产品编号',
      productName: '商品名称',
      productDesc: '商品简介',
      specId: '规格编号',
      externalCode: '外部编码',
      state: '状态',
      syncSuccess: '同步成功',
      syncFailed: '同步失败',
      syncRemark: '同步说明',
      syncTime: '同步时间',
      operation: '操作',
      delete: '删除',
      selectPartner: '请选择合作商'
    }
  }
}